import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import PhoneCallbackIcon from "@mui/icons-material/PhoneCallback";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { CALL_DIRECTION_OUTGOING } from "constants/suno-comms";

type CallDirectionProps = {
  direction: string;
};
export default function CallDirection({ direction }: CallDirectionProps) {
  return (
    <Stack direction="row" spacing={1}>
      {direction.toLocaleLowerCase() === CALL_DIRECTION_OUTGOING ? (
        <>
          <PhoneForwardedIcon sx={{ fontSize: "20px" }} />
          <Typography sx={{ fontSize: "14px" }}>{direction}</Typography>
        </>
      ) : (
        <>
          <PhoneCallbackIcon sx={{ fontSize: "20px" }} />
          <Typography sx={{ fontSize: "14px" }}>{direction}</Typography>
        </>
      )}
    </Stack>
  );
}
